<header class="header">
   <card-header title="{{ 'CASES.ADD_TO_SERVICE_PROVIDER' | translate }}">
   </card-header>
   <div class="header__actions">
      <form class="form" [formGroup]="serviceProviderFormAdd" style="width: 100%;">
         <field-holder>
            <mat-form-field appearance="outline">
               <mat-label>{{ 'GLOBAL.SUBJECT.SERVICE_PROVIDER' | translate }}</mat-label>
               <input type="text" matInput formControlName="serviceProvider"
                  [matAutocomplete]="autoServiceProvider" autocomplete="off"
                  placeholder="{{ 'SERVICE_PROVIDERS.SEARCH_SERVICE_PROVIDERS' | translate }}"/>

               <mat-autocomplete #autoServiceProvider="matAutocomplete" [displayWith]="displayServiceProvider">
                  <mat-option *ngFor="let option of filteredServiceProviders | async" [value]="option">
                  {{ option.name }}
                  </mat-option>
               </mat-autocomplete>

               <mat-error *ngIf=" serviceProviderFormAdd.get('serviceProvider').hasError('required') || serviceProviderFormAdd.get('serviceProvider').hasError('notValid')">
                  {{ 'SERVICE_PROVIDERS.SERVICE_PROVIDER_ERROR' | translate }}
               </mat-error>
            </mat-form-field>
         </field-holder>
         <field-holder>
            <mat-form-field appearance="outline">
                <mat-select formControlName="providedService" [compareWith]="compareObjects">
                    <mat-option *ngFor="let providedService of providedServices; let i = index" [value]="providedService">{{ providedService.title }}</mat-option>
                </mat-select>
                <mat-label>{{ 'SERVICE_PROVIDERS.CREATE.LICENCE.PROVIDED_SERVICE' | translate }}</mat-label>
                <mat-error *ngIf="serviceProviderFormAdd.get('providedService').hasError('required')">{{ 'SERVICE_PROVIDERS.CREATE.LICENCE.PROVIDED_SERVICE_ERROR' | translate }}</mat-error>
            </mat-form-field>
         </field-holder>
         <field-holder>
            <mat-form-field appearance="outline">
               <mat-label>{{ 'SERVICE_PROVIDERS.CREATE.RIGHT_GRANTED_DATE' | translate }}</mat-label>
               <input matInput [matDatepicker]="rightGrantedDate"
               formControlName="rightGrantedDate" autocomplete="off" />
               <mat-datepicker-toggle matSuffix [for]="rightGrantedDate"></mat-datepicker-toggle>
               <mat-datepicker #rightGrantedDate></mat-datepicker>
               <mat-error *ngIf="serviceProviderFormAdd.get('rightGrantedDate').hasError('required')">
                   {{ 'SERVICE_PROVIDERS.CREATE.RIGHT_GRANTED_DATE_ERROR' | translate }}
               </mat-error>
            </mat-form-field>
         </field-holder>
         <form-footer>
            <button mat-stroked-button color="primary" class="form-footer__button" (click)="sendRequest()"
               [disabled]="!serviceProviderFormAdd.valid">
               {{ 'SIDEBAR_WIDGET.OTHER_INSTITUTIONS.SUBMIT' | translate }}
            </button>
            <button mat-stroked-button color="primary" mat-dialog-close (click)="closeDialog()"
              class="modal-footer__button modal-footer__button--secondary">
               {{ 'WARNING_DIALOG.CANCEL' | translate }}
            </button>
         </form-footer>
      </form>
   </div>
</header>